import React from 'react';
import { Input, Button, Link, Text, Box } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { getOrder } from '../api';
import RefundButton from '../components/RefundButton';

function OrderIdInput() {
  const URL =
    window.location.hostname === 'localhost'
      ? 'http://localhost:3000'
      : 'https://' + window.location.hostname;

  const [isLoading, setIsLoading] = React.useState(false);
  const [orderId, setOrderId] = React.useState('');
  const [order, setOrder] = React.useState();
  const [error, setError] = React.useState('');
  const handleChange = (event) => {
    setError('');
    setOrder();
    setOrderId(event.target.value);
  };
  
  return (
    <>
      {error && (
        <Text fontSize={'lg'} color='tomato' mb={5}>
          {error}
        </Text>
      )}
      {order && (
        <Box p={1} my={3} border={'1px solid teal'} borderRadius={5}>
          <Box>
            <Link color={'gold'} href={URL + '/checkout-ok/' + orderId} isExternal>
              <Text>
                {orderId} <ExternalLinkIcon mx='2px' />
              </Text>
            </Link>
            <Text>creato il {new Date(order.createdAt).toLocaleString('it', {
              month: 'long',
              day: 'numeric',
              year: '2-digit',
              hour: 'numeric',
              minute: 'numeric'
            })}</Text>
            <Text>email {order.email || 'N/A'}</Text>
            <Text>status {order.status}</Text>
            {order.paymentType ? (
              <Text>paymentType {order.paymentType}</Text>
            ) : (
              <Text>paymentType STRIPE</Text>
            )}
            {/* Aggiungi il pulsante RefundButton */}
            <RefundButton 
              orderId={orderId}
              paymentId={order.paymentId}
              paymentType={order.paymentType}
              status={order.status}
              settledBy={order.settledBy}
              onRefundSuccess={() => {
                // Aggiorna lo stato dell'ordine localmente
                setOrder(prevOrder => ({ ...prevOrder, status: 'refunded' }));
              }}
              buttonProps={{ mt: 2 }}
            />
          </Box>
        </Box>
      )}
      <Input my={5} value={orderId} onChange={handleChange} placeholder='orderId' size='sm' />
      <Button
        isLoading={isLoading}
        isDisabled={!orderId}
        onClick={async () => {
          setError('');
          setOrder();
          setIsLoading(true);
          const data = await getOrder(orderId);
          setIsLoading(false);
          if (data.error) {
            setError(data.error);
          } else {
            // console.log('DATA', data);
            setOrder(data);
          }
        }}
      >
        Cerca
      </Button>
    </>
  );
}

export default OrderIdInput;
